import { ReactNode } from 'react';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogDescription, DialogTitle } from '@/new/components/shadcn/dialog';

interface ConfirmationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
  onConfirm: () => void;
  isLoading: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  onOpenChange,
  title,
  children,
  onConfirm,
  isLoading,
  ...props
}: ConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange} {...props}>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="mb-6">
          {isLoading ? (
            <div className="flex justify-center p-2 text-gray-500">
              <Icon className="lucide--loader-2 h-6 w-6 animate-spin duration-1500" />
            </div>
          ) : (
            children
          )}
        </div>

        <div className="flex justify-end gap-2">
          <Button onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button data-testid="confirm-button" variant="primary" onClick={onConfirm} disabled={isLoading}>
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
